import { render, staticRenderFns } from "./TypePay.vue?vue&type=template&id=10678efb&scoped=true"
import script from "./TypePay.vue?vue&type=script&lang=js"
export * from "./TypePay.vue?vue&type=script&lang=js"
import style0 from "./TypePay.vue?vue&type=style&index=0&id=10678efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10678efb",
  null
  
)

export default component.exports